import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as EventBus from '@vertx/eventbus-bridge-client.js';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

export interface NotificationAlert {
  sendTo?: string[];
  content: string;
  type: string;
  severity: string;
  eventTime: string;
  broadcast?: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class EventbusConnectionService {
  public eventBus: EventBus = null;
  readonly eventBroadcastResponse = new BehaviorSubject(null);
  eventBroadcastResponse$ = this.eventBroadcastResponse.asObservable();

  readonly eventSelectedUserResponse = new BehaviorSubject(null);
  eventSelectedUserResponse$ = this.eventSelectedUserResponse.asObservable();

  constructor(private toastr: ToastrService) {
    // this.initializeEventBusConnection();
  }

  get token() {
    return JSON.parse(localStorage.getItem('Token'));
  }

  initializeEventBusConnection() {
    console.log('initializeEventBusConnection');
    this.eventBus = new EventBus(this.getSocketUrl(), { withCredentials: true });
    this.eventBus.onopen = () => {
      this.eventBus.registerHandler('/rtevents/broadcast', (err, res) => {
        const body = JSON.parse(res?.body);
        console.log('body:Event ', body);
        this.eventBroadcastResponse.next(body);
        console.log("broadcast messages received", res);
        if (body?.type === 'notification') {
          if (body?.data?.content.includes('href=')) {
            let modifiedMessage: string = '';
            const origionalMessage: string = body?.data?.content;
            modifiedMessage = origionalMessage.substring(0, origionalMessage.indexOf('<a'))
            modifiedMessage = modifiedMessage + '"' + origionalMessage.substring(origionalMessage.indexOf('>') + 1, origionalMessage.indexOf('</a'))+ '"';
            modifiedMessage = modifiedMessage + origionalMessage.slice(origionalMessage.indexOf('auto') - 1, origionalMessage.length)
            this.toastr.info(modifiedMessage || '');
          } else {
            this.toastr.info(body?.data?.content || '');
          }
        }
      });

      this.eventBus.registerHandler('/rtevents/users/' + this.token?.userName, (err, res) => {
        console.log("specific messages received", res);
        const body = JSON.parse(res?.body);
        console.log('body:Event2 ', body);
        this.eventSelectedUserResponse.next(body);
        if (body?.type === 'notification') {
          this.toastr.info(body?.data?.content || '');
        }
      });
    };
  }

  closeSocketConnection(){
    console.log('closeSocketConnection: ');
    if(this.eventBus){
      this.eventBus.close();
      this.eventBus.onclose = (params) => {
        console.log('closed', params);
        params.cancelable = true;
      }

      this.eventBus = null;
      console.log('object :>> WS Closed');
    }
  }

  private getSocketUrl() {
    let socketUrl = environment.BASE_URL + 'rtevents/';
    if (this.token?.accessToken) {
      socketUrl += this.token.userName + '/' + this.token.accessToken
    }

    return socketUrl;
  }

}